<template>
  <b-container fluid class="p-0">
    <b-row class="p-3 mt-5" v-if="!successAuth">
      <b-col md="5" offset-md="3">
        <b-row>
          <b-col cols="12">
            <b-alert show :variant="dica">
              {{ dicaTexto }}
            </b-alert>
          </b-col>
        </b-row>
        <div>
          <b-card :header="header" header-tag="header">
            <b-card-text>
              <b-form @submit.stop.prevent="onSubmit" novalidate>
                <b-row>
                  <b-col cols="12" v-if="this.token == null || this.token.length == 0">
                    <b-form-group label="CPF">
                      <b-form-input v-model="user.cpf" v-mask="'###.###.###-##'" v-on:keyup="validarCPF()"
                        @keydown.enter.stop.prevent :state="validateCPF" required>
                      </b-form-input>
                      <b-form-invalid-feedback>
                        CPF é obrigatório e deve ser válido.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Login Form -->
                <b-row v-if="
                  this.user.id !== null &&
                  this.user.id > 0 &&
                  this.cpf_isvalido &&
                  (this.token == null || this.token.length == 0)
                ">
                  <b-col cols="12">
                    <b-form-group label="Senha">
                      <b-form-input ref="inputSenha" v-model="user.senha" type="password" @keydown.enter="logar"
                        required>
                      </b-form-input>
                    </b-form-group>
                    <b-button block variant="success" @keydown.enter="logar" @click="logar" class="mb-3">
                      <font-awesome-icon icon="sign-in-alt" />
                      Login do Candidato
                    </b-button>
                    <b-button block variant="danger" @click="recover" class="mr-3">
                      <font-awesome-icon icon="sign-in-alt" />
                      Esqueci minha senha
                    </b-button>
                  </b-col>
                </b-row>

                <!-- Registration Form -->
                <b-row v-if="
                  (this.user.id == null || this.user.id == 0) &&
                  this.cpf_isvalido &&
                  (this.token == null || this.token.length == 0)
                ">
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="12">
                        <b-form-group label="Nome Completo">
                          <b-form-input v-model="user.nome" @keydown.enter.stop.prevent :state="validateNome" required>
                          </b-form-input>
                          <b-form-invalid-feedback>
                            Nome é obrigatório e deve ter pelo menos 2 caracteres.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="E-mail">
                          <b-form-input v-model="user.email" type="email" @keydown.enter.stop.prevent
                            :state="validateEmail" required>
                          </b-form-input>
                          <b-form-invalid-feedback>
                            E-mail é obrigatório e deve ser válido.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Data de Nascimento">
                          <b-form-input v-model="user.data_nascimento" type="date" @blur="validarIdade"
                            @keydown.enter.stop.prevent :state="validateNascimento" required>
                          </b-form-input>
                          <b-form-invalid-feedback>
                            Data de nascimento é obrigatória e você deve ter pelo menos 14 anos.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Sexo">
                          <b-form-select v-model="user.genero" :options="sexoOptions" @keydown.enter.stop.prevent
                            :state="validateSexo" required>
                          </b-form-select>
                          <b-form-invalid-feedback>
                            Sexo é obrigatório.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Telefone">
                          <b-form-input v-model="user.telefone" v-mask="'(##) #####-####'" placeholder="(11) 99999-9999"
                            @keydown.enter.stop.prevent :state="validateTelefone" required>
                          </b-form-input>
                          <b-form-invalid-feedback>
                            Telefone é obrigatório e deve ter formato válido.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-group label="Estado">
                              <b-form-select v-model="user.estado_id" :options="estadosOptions" @change="atualizarCidades"
                                @keydown.enter.stop.prevent :state="validateEstado" required>
                              </b-form-select>
                              <b-form-invalid-feedback>
                                Estado é obrigatório.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" md="6">
                            <b-form-group label="Cidade">
                              <b-form-select v-model="user.cidade_id" :options="cidadesOptions" @keydown.enter.stop.prevent
                                :state="validateCidade" :disabled="!cidadeIsReady" required>
                              </b-form-select>
                              <b-form-invalid-feedback>
                                Cidade é obrigatória.
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Senha (Minimo 6 caracteres)">
                          <b-input-group>
                            <b-form-input v-model="user.senha" :type="showPassword ? 'text' : 'password'"
                              @keydown.enter.stop.prevent :state="validateSenha" required>
                            </b-form-input>
                            <b-input-group-append>
                              <b-button variant="outline-secondary" @click="showPassword = !showPassword">
                                <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <b-form-invalid-feedback>
                            Senha é obrigatória e deve ter pelo menos 6 caracteres.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Envie seu currículo em formato PDF" label-for="input-1">
                          <b-form-file id="curriculoAnexo" ref="cvInput" type="file" name="curriculoAnexo" accept=".pdf"
                            placeholder="Arquivo em formato pdf" @change="uploadCurriculo" :state="validateCurriculo">
                          </b-form-file>
                          <b-form-invalid-feedback>
                            Currículo em PDF é obrigatório.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-button class="mt-3" block variant="success" @click="cadastrar">
                          Efetuar Cadastro
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { sharedService } from "../../services";

export default {
  data() {
    return {
      senha_confirmar: "",
      header: "Área do Candidato - Login",
      dica: "",
      dicaTexto: "",
      cpf_isvalido: false,
      googleObj: {},
      successAuth: false,
      showPassword: false,
      idadeValida: true,
      formTouched: false, 
      cidadeIsReady: false,
      cidadesOptions: [{ value: null, text: "Selecione a cidade" }],     
      sexoOptions: [
        { value: null, text: "Selecione o sexo" },
        { value: "M", text: "Masculino" },
        { value: "F", text: "Feminino" },
      ],
      estadosOptions: [
        { value: null, text: "Selecione o estado" },
        { value: "1", text: "Acre" },
        { value: "2", text: "Alagoas" },
        { value: "3", text: "Amapá" },
        { value: "4", text: "Amazonas" },
        { value: "5", text: "Bahia" },
        { value: "6", text: "Ceará" },
        { value: "7", text: "Distrito Federal" },
        { value: "8", text: "Espírito Santo" },
        { value: "9", text: "Goiás" },
        { value: "10", text: "Maranhão" },
        { value: "11", text: "Mato Grosso" },
        { value: "12", text: "Mato Grosso do Sul" },
        { value: "13", text: "Minas Gerais" },
        { value: "14", text: "Pará" },
        { value: "15", text: "Paraíba" },
        { value: "16", text: "Paraná" },
        { value: "17", text: "Pernambuco" },
        { value: "18", text: "Piauí" },
        { value: "19", text: "Rio de Janeiro" },
        { value: "20", text: "Rio Grande do Norte" },
        { value: "21", text: "Rio Grande do Sul" },
        { value: "22", text: "Rondônia" },
        { value: "23", text: "Roraima" },
        { value: "24", text: "Santa Catarina" },
        { value: "25", text: "São Paulo" },
        { value: "26", text: "Sergipe" },
        { value: "27", text: "Tocantins" },
      ],
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    token: function () {
      return this.$store.getters.getToken;
    },    
    // Validations
    validateCPF() {
      return this.cpf_isvalido;
    },
    validateNome() {      
      return this.user.nome != null && this.user.nome.trim().length >= 2;
    },
    validateEmail() {      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return this.user.email != null && emailRegex.test(this.user.email);
    },
    validateNascimento() {            
      return this.validarIdade();
    },
    validateSexo() {      
      return this.user.genero != null;
    },
    validateTelefone() {      
      const telefoneClean = this.user.telefone ? this.user.telefone.replace(/\D/g, '') : '';
      return telefoneClean.length === 11;
    },
    validateSenha() {      
      return this.user.senha != null && this.user.senha.length >= 6;
    },
    validateCurriculo() {      
      return this.user.curriculo !== null && this.user.curriculo !== undefined;
    },
    validLoginForm() {
      return this.cpf_isvalido && this.user.senha;
    },
    validRegisterForm() {      
      return this.validateNome &&
        this.validateEmail &&
        this.validateNascimento &&
        this.validateSexo &&
        this.validateTelefone &&
        this.validateSenha &&
        this.validateCurriculo &&        
        this.validateCPF && this.validateCidade && this.validateEstado;
    },
    validateCidade() {          
      console.log("Validando cidade:", this.user.cidade_id);
      return    this.user.cidade_id !== null && this.user.cidade_id !== undefined && this.user.cidade_id !== "";
    },
    validateEstado() {      
      return this.user.estado_id !== null && this.user.estado_id !== undefined && this.user.estado_id !== "";
    }

  },
  beforeMount() {
    if (this.user.id == null || this.user.id == 0) {
      (this.dica = "info"),
        (this.dicaTexto = "Para começar, informe o seu CPF");
    } else {
      (this.dica = ""), (this.dicaTexto = "");
    }
  },
  methods: {
    onSubmit() {
      this.formTouched = true;
      if (this.user.id !== null && this.user.id > 0) {
        this.logar();
      } else {
        this.cadastrar(event);
      }
    },
    async atualizarCidades() {
      if (this.user.estado_id) {
        let self = this;
        self.cidadesOptions = [];
        self.cidadeIsReady = false;
        this.cidadesOptions = [{ value: null, text: "Selecione a cidade" }];
        await sharedService
          .read("Candidato/cidades", { estado: this.user.estado_id })
          .then(function (obj) {            
            self.cidadesOptions = [{ value: null, text: "Selecione a cidade" }, ...obj];
            self.cidadeIsReady = true;
          });
      }
    },    
    async logar() {
      let self = this;
      this.$store.dispatch("signUserIn", null).then(function () {
        if (self.token == null || self.token.length == 0) {
          self.$swal({
            icon: "error",
            position: "top",
            title: "Oops...",
            text: "Login Incorreto!",
            footer:
              "<b>Verifique os dados informados e tente novamente, caso não lembre clique no botão [Esqueci minha senha], e um email será encaminhado com instruções!!!</b>",
          });
        }
      });
    },
    async logarToken() {
      let self = this;
      this.$store.dispatch("signUserIn", null).then(function () {
        if (self.token == null || self.token.length == 0) {
          self.$router.push({
            name: "curriculo_cpf_token",
          });
        }
      });
    },
    async uploadCurriculo() {
      let self = this;
      await sharedService
        .sendFiles(
          "Candidato/anexo",
          // eslint-disable-next-line
          curriculoAnexo.files[0],
          this.$store.getters.getApiKey
        )
        .then(function (obj) {
          obj.text().then(function (text) {
            if (obj.status === 200) {
              let curriculo = JSON.parse(text);
              self.user.curriculo = curriculo;
            }
          });
        });
    },
    validarIdade() {
      const hoje = new Date();
      if(this.user.data_nascimento == null || this.user.data_nascimento === undefined || this.user.data_nascimento === "") { 
        this.idadeValida = false;
        return false;
      }      
      const nascimento = new Date(this.user.data_nascimento);
      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const m = hoje.getMonth() - nascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
      }      
      this.idadeValida = idade >= 14;
      return this.idadeValida;
    },
    irVagas() {
      this.$router.push({
        name: "vagas_encaminhadas",
      });
    },
    editarCurriculo() {
      if (this.user.id !== 0) {
        this.$router.push({
          name: "curriculo",
        });
      }
    },
    cadastrar: function (e) {
      if (e) e.preventDefault();

      this.formTouched = true;

      if (!this.validRegisterForm) {
        this.$swal({
          icon: "warning",
          position: "top",
          title: "Campos obrigatórios",
          text: "Por favor, preencha todos os campos obrigatórios corretamente!",
        });
        return;
      }

      let loader = this.$loading.show();
      let self = this;
      let key = this.$store.getters.getApiKey || null;

      this.$store.dispatch("storeUser", null).then(function (obj) {
        obj.text().then(function (text) {
          if (obj.status === 200) {
            self
              .$swal({
                icon: "success",
                position: "top",
                title: "Cadastro Efetuado",
                html: "<p>Seu Curriculo esta salvo em nossa base de dados</b>, logo entraremos em contato com oportunidades de emprego</p> Enquanto isso, verifique em nossas vagas e encaminhe seu currículo para aquelas que se adequam ao seu perfil",
                footer: "Dados salvos com sucesso",
              })
              .then(function () {
                console.log(JSON.parse(text));
                self.$store.dispatch("setarUsuario", {                  
                  usuario: JSON.parse(text).usuario,
                  token: JSON.parse(text).token,
                }).then(function () {
                  self.$router.push({
                    name: "curriculo_main",
                    query: {
                      api_key: key,
                    },
                  });
                });
              });
          } else {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Erro ao salvar seu cadastro",
              html: "Não foi possivel salvar seu curriculo no momento, por favor tente em alguns minutos! ",
              footer: text,
            });
          }
        }).finally(() => {
          loader.hide();
        })
      });
    },
    recover() {
      let self = this;
      let loader = this.$loading.show();
      sharedService
        .createRecuperar(
          "Candidato/recuperarsenha",
          { cpf: this.user.cpf },
          this.$store.getters.getApiKey
        )
        .then(function (obj) {
          if (obj.status === 200) {
            self.$swal({
              icon: "info",
              position: "top",
              title: "Recuperar Senha",
              text: "Foi encaminhado para o seu email cadastrado um link para alterar a sua senha cadastrada.",
              footer:
                "verifique na sua caixa de entrada, caso não encontre, de uma olhadinha na caixa de SPAM!!!",
            });
          } else {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Oops...",
              text: "Não foi possivel recuperar a sua senha!",
              footer:
                "Os dados fornecidos não permitem encaminhar um email para recuperar sua senha, por favor entre em contato",
            });
          }
          loader.hide();
        });
    },
    validarCPF(val) {
      let self = this;
      val = this.user.cpf;
      this.cpf_isvalido = false;
      if (val.length === 14) {
        let aux = 10;
        let somatoria = 0;
        for (var i = 0; i <= 8; i++) {
          somatoria =
            somatoria +
            val.replace(".", "").replace(".", "").replace("-", "")[i] * aux;
          aux = aux - 1;
        }

        let multiplicao = (somatoria * 10) % 11;
        if (multiplicao === 10 || multiplicao === 11) {
          multiplicao = 0;
        }

        if (
          val === "000.000.000-00" ||
          val === "111.111.111-11" ||
          val === "222.222.222-22" ||
          val === "333.333.333-33" ||
          val === "444.444.444-44" ||
          val === "555.555.555-55" ||
          val === "666.666.666-66" ||
          val === "777.777.777-77" ||
          val === "888.888.888-88" ||
          val === "999.999.999-99"
        ) {
          self.dicaTexto = "CPF Inválido!";
          self.dica = "danger";
        } else if (
          multiplicao ===
          Number(val.replace(".", "").replace(".", "").replace("-", "")[9])
        ) {
          let aux2 = 11;
          let somatoria2 = 0;

          for (var j = 0; j <= 9; j++) {
            somatoria2 =
              somatoria2 +
              val.replace(".", "").replace(".", "").replace("-", "")[j] * aux2;
            aux2 = aux2 - 1;
          }

          let multiplicao2 = (somatoria2 * 10) % 11;
          if (multiplicao2 === 10 || multiplicao2 === 11) {
            multiplicao2 = 0;
          }
          if (
            multiplicao2 ===
            Number(val.replace(".", "").replace(".", "").replace("-", "")[10])
          ) {
            this.$store.dispatch("verificaCPF", val).then(function () {
              self.cpf_isvalido = true;
              self.dicaTexto = "";
              self.dica = "";              
            });
          } else {
            self.dicaTexto = "CPF Inválido!";
            self.dica = "danger";
          }
        } else {
          self.dicaTexto = "CPF Inválido!";
          self.dica = "danger";
        }
      }
    },
  },
};
</script>

<style scoped>
.alert-info {
  color: #ffffff;
  background-color: #d94452;
  border-color: #d94452;
  border-bottom: 5px solid #eb5463;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
  border-bottom: 5px solid #e6debd;
}

.btn-success {
  background-color: #4cba9b;
  border-color: #4cba9b;
}

.btn-success:disabled {
  opacity: 0.5;
}

.btnGoogle {
  background: #4485f4;
  border: none;
  padding: 0.6rem 0.6rem;
  font-weight: bold;
  border-radius: 5px;
  color: #ffffff;
  width: 100%;
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
}
</style>
